import React, { useState } from 'react';

import Axios from 'axios';

import NwDrawer from '@components/Gui/NwDrawer';
import PdfPrintDrawer from '@components/PdfPrintDrawer/PdfPrintDrawer';
import IconTemplateSelector from '@components/TemplateSelector/IconTemplateSelector';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ExportContact = ({ contact, type }) => {
    const [isFillingTemplate, setIsFillingTemplate] = useState(false);
    const [docVersion, setDocVersion] = useState(null);

    const areaName = type.toLowerCase() === 'model' ? 'Model' : 'Customer';

    const handleGenerateExport = async (templateid) => {
        setIsFillingTemplate(true);
        //create data object to send with all IDs array
        const data = {
            Template: templateid,
            Area: areaName,
            OutputFileName: areaName,
            ID: contact.ID,
        };
        const exportResponse = await Axios.post(`/${type.toLowerCase()}s/print`, data);
        setDocVersion(exportResponse);
        setIsFillingTemplate(false);
    };

    return (
        <>
            <IconTemplateSelector
                icon={byPrefixAndName.fasl['share']}
                templateArea={areaName}
                placement="left"
                onClick={handleGenerateExport}
            />
            {docVersion && (
                <NwDrawer
                    onClose={() => setDocVersion(null)}
                    padding="0px"
                    title="Print"
                    visible={true}
                    whiteBg={false}
                    width="80vw"
                    maxWidth={'1024px'}
                >
                    <PdfPrintDrawer docVersion={docVersion} />
                </NwDrawer>
            )}
        </>
    );
};

export default ExportContact;
